import { csvFormat } from "d3-dsv";

export const downloadFile = ({
  data,
  extension = ".txt",
  type = "text/plain",
}) => {
  const fileData = new Blob([data], { type });

  // If we are replacing a previously generated file we need to
  // manually revoke the object URL to avoid memory leaks.
  if (fileData !== null) {
    window.URL.revokeObjectURL(fileData);
  }

  const fileUrl = URL.createObjectURL(fileData);

  const a = document.createElement("a");
  document.body.appendChild(a);
  a.setAttribute("download", `WindRose.xyz-data${extension}`);
  a.setAttribute("href", fileUrl);
  a.style.display = "none";
  a.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(fileData);
    document.body.removeChild(a);
  }, 1000);
};

export const formatJSON = (data) => JSON.stringify(data, null, 2);

export const formatCSV = (data) => csvFormat(data);
